<template>
  <div>
    缓存快：<el-input v-model="cacheBlock" size="mini"></el-input>
    <br>
    缓存key：<el-input v-model="cacheKey" size="mini"></el-input>
    <br>
    <el-button @click="clearCache" type="primary" size="mini">clear cache</el-button>
  </div>
</template>
<script>
  import util from '../../libs/util'
  export default {
    name: 'cache-clear',
    data() {
      return {
        cacheBlock: '',
        cacheKey: ''
      }
    },
    methods: {
      clearCache() {
        let params = {
          cacheBlock: this.cacheBlock,
          cacheKey: this.cacheKey
        }
        util.ajax.post('/superAdmin/cacheManage/clearCache', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: '缓存清除完成'})
          } else {
            this.$notify.error({title: '错误', message: '缓存清除失败'})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '缓存清除失败'})
          console.error(err)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/super-admin/cache/cache-clear.vue